import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentRemove from 'material-ui/svg-icons/action/delete';

/**
 * A component for creating a named item with optional removal.
 * Loaded by AccessTable.
 *
 */
class AccessTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
    }

    handleRemoveClick() {
        this.props.onRemoveClick(this.props.name);
    }

    render() {
        const styles = {
            block: {display: 'block'},
            row: {height: '40px'},
            alignTop: {verticalAlign: 'top'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            fieldSmall: {display: 'inline-block', maxWidth: 100, maxHeight: 62},
        };
        return (
            <TableRow style={styles.row}>
                <TableRowColumn colSpan={2} className={'row-access-' + this.props.name} style={styles.row}>
                    <span>{this.props.name}</span>
                </TableRowColumn>

                <TableRowColumn style={styles.row}>
                    {this.props.showRemove &&
                    <IconButton
                        style={styles.icon}
                        onClick={(e) => this.handleRemoveClick(e)}
                    >
                        <ContentRemove color={FuseTheme.palette.primary1Color}/>
                    </IconButton>
                    }
                </TableRowColumn>
            </TableRow>
        )
    }
}

AccessTableRow.propTypes = {
    addField: PropTypes.bool,
    name: PropTypes.string.isRequired,
    showRemove: PropTypes.bool,
    onRemoveClick: PropTypes.func,
};

AccessTableRow.defaultProps = {
    addField: true,
    name: '',
    style: {padding: 0},
};

export default AccessTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/AccessTableRow.js